import React, { useEffect, useRef, useState } from 'react';
import TemplateDesignService from '../../../../services/TemplateDesign.service';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import Complete from './Complete';
import { BackTop, Button, Checkbox, Form, Input, Radio, Space } from 'antd';
import GlobalService from '../../../../services/Global.service';
import months from '../../months.json';
import IconNoData from '../../../../assets/Images/icons/icon-no-data';
import styled from 'styled-components';
import useQuery from '../../../../util/useQuery';
import classNames from 'classnames';
import { sendHeightToIframeConsent } from '../../../policy/sendHeight';
import { CheckCircleFilled } from '@ant-design/icons';
import useOtp from './hook';

export default function Consent() {
    // key test dbfed2abb1f64bff881
    const { key, lang } = useParams();
    const [form] = Form.useForm();
    const [_, forceUpdate] = useState({});

    const [templateDetail, setTemplateDetail] = useState();
    const [imageId, setImageId] = useState('');
    const [consentForms, setConsentForms] = useState();
    const [image, setImageSrc] = useState();
    const [isSubmit, setIsSubmit] = useState(false);

    const params = useQuery();

    const ref = useRef();

    const {
        getOtp,
        verifyOtp,
        disableOtp,
        email,
        count,
        isRequireOtp,
        refCode,
        resultData,
        isValidOtp,
        disabledEmail,
    } = useOtp({
        form,
        imageId,
        templateDetail,
        lang,
    });

    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImageNoSecure(imageId);
                if (data.resultData?.imageId) {
                    setImageSrc(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (imageId) getImage();
        else setImageSrc(null);
    }, [imageId]);

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'th' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'th' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const currentDate = new Date(date);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    const getTemplateDetail = async () => {
        try {
            const { data } =
                await TemplateDesignService.getTemplateConsentPublishNoSecure(
                    key
                );
            if (data?.resultData) {
                const item = data?.resultData;
                setTemplateDetail(item);
                setImageId(item?.logoId ?? '');
                setConsentForms(item?.consentForms);
                sendHeightToIframeConsent(ref.current);
            }
        } catch (error) {}
    };

    useEffect(() => {
        getTemplateDetail();
        if (params.get('ember') === '1') {
            document.body.style.background = 'transparent';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        forceUpdate({});
    }, []);

    const onFinish = async (values) => {
        if (templateDetail?.isRequireOtp) {
            if (!isValidOtp) {
                return form.setFields([
                    {
                        name: 'otp',
                        errors: [
                            lang === 'th'
                                ? 'กรุณากดยืนยันรหัส OTP'
                                : 'Please confirm OTP.',
                        ],
                    },
                ]);
            }
        }
        const acceptance = [];
        const new_item = values?.new_item || [];
        const identity = new_item.join(' ');
        for (const item in consentForms) {
            if (consentForms[item]?.consentId) {
                acceptance.push({
                    consentId: consentForms[item]?.consentId,
                    identity,
                    isAccept: Boolean(
                        form.getFieldValue(consentForms[item]?.consentId)
                    ),
                    collectionPointName: '',
                    // version: consentForms[item]?.version,
                });
            }
        }
        let payload = {
            templateId: templateDetail?.templateId,
            acceptance: acceptance,
        };

        if (templateDetail?.isRequireOtp) {
            payload = {
                ...payload,
                email,
                otpTxnId: resultData?.otpTxnId,
            };
        }

        try {
            const { data } =
                await TemplateDesignService.addNewTemplateAcceptance(payload);
            if (data?.resultMsg === 'SUCCESS') {
                setIsSubmit(true);
            } else {
                setIsSubmit(false);
            }
        } catch (error) {
            setIsSubmit(false);
        }
    };

    const help =
        lang === 'th'
            ? `<span className="text-blue-100">กรุณาตรวจสอบอีเมลของท่าน หากไม่ได้รับรหัส สามารถขอรับรหัสใหม่ต้องรอ <span className="text-black font-semibold">${count}</span> วินาที \nโปรดระบุรหัส OTP ที่ได้รับ ภายในเวลา 5 นาที</span>`
            : `<span className="text-blue-100">Please check your email. If you do not receive the code, you can request a new code. You have to wait <span className="text-black font-semibold">${count}</span> seconds \nPlease enter the OTP code received within 5 minutes</span>`;

    const required_sign = <span className="required_sign">*</span>;

    return (
        <div className="w-full h-full">
            <TemplateDetail
                ref={ref}
                className={classNames({
                    'm-0 w-full': params.get('ember') === '1',
                    'max-w-6xl m-auto my-5 border-[1px] border-solid border-[#ECECEC] rounded-md':
                        !params.get('ember'),
                })}
            >
                {isSubmit === false ? (
                    <>
                        {templateDetail ? (
                            <Form
                                layout="vertical"
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                }}
                                form={form}
                                onFinish={onFinish}
                            >
                                <div className="whitespace-pre-line m-4 mt-2 px-5 py-6 leading-7">
                                    <div className="text-center">
                                        <div
                                            className="text-center my-4 justify-center"
                                            hidden={!image}
                                        >
                                            <img
                                                src={image}
                                                height={70}
                                                className="object-cover w-auto h-20"
                                                alt={
                                                    lang === 'en'
                                                        ? 'Logo'
                                                        : 'โลโก้'
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="text-center text-xl font-semibold whitespace-pre-wrap"
                                        style={{
                                            wordBreak: 'break-word',
                                        }}
                                    >
                                        {lang === 'en'
                                            ? parse(
                                                  templateDetail?.titleEn || '-'
                                              )
                                            : parse(
                                                  templateDetail?.titleTh || '-'
                                              )}
                                    </div>
                                    <div
                                        className="my-2"
                                        style={{
                                            borderBottom: '1px solid #EDEEF9',
                                        }}
                                    ></div>
                                    <div className="text-sm font-semibold whitespace-pre-wrap mb-4">
                                        {lang === 'en'
                                            ? parse(
                                                  templateDetail?.templateNameEn ||
                                                      '-'
                                              )
                                            : parse(
                                                  templateDetail?.templateNameTh ||
                                                      '-'
                                              )}
                                    </div>

                                    {templateDetail?.templateDesignIdentity
                                        ?.map((item, index) => {
                                            return (
                                                <Form.Item
                                                    name={['new_item', index]}
                                                    className="w-full"
                                                    key={
                                                        item?.labelNameTh +
                                                        index
                                                    }
                                                    label={
                                                        lang === 'th'
                                                            ? item?.labelNameTh
                                                            : item?.labelNameEn
                                                    }
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                lang === 'en'
                                                                    ? 'This field is required.'
                                                                    : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        size="large"
                                                        maxLength={50}
                                                        showCount
                                                    />
                                                </Form.Item>
                                            );
                                        })
                                        .sort(
                                            (a, b) => a.sequence - b.sequence
                                        )}

                                    <div className="text-sm font-base whitespace-pre-wrap indent-12">
                                        {lang === 'en'
                                            ? parse(
                                                  templateDetail?.firstParagraphEn ||
                                                      '-'
                                              )
                                            : parse(
                                                  templateDetail?.firstParagraphTh ||
                                                      '-'
                                              )}
                                    </div>

                                    {consentForms?.map((consent, index) => (
                                        <div className="mt-2" key={index}>
                                            {consent?.noteId ? (
                                                parse(
                                                    `${
                                                        lang === 'en'
                                                            ? consent?.titleEn
                                                            : consent?.titleTh
                                                    }`
                                                )
                                            ) : (
                                                <>
                                                    <div className="text-sm font-semibold whitespace-pre-wrap">
                                                        {lang === 'en'
                                                            ? parse(
                                                                  consent?.consentNameEn ||
                                                                      '-'
                                                              )
                                                            : parse(
                                                                  consent?.consentNameTh ||
                                                                      '-'
                                                              )}
                                                    </div>
                                                    <div className="text-sm font-base whitespace-pre-wrap">
                                                        {lang === 'en'
                                                            ? parse(
                                                                  consent?.purposeEn ||
                                                                      '-'
                                                              )
                                                            : parse(
                                                                  consent?.purposeTh ||
                                                                      '-'
                                                              )}
                                                    </div>
                                                    {consent?.isConsented ? (
                                                        <Form.Item
                                                            className="initial"
                                                            name={
                                                                consent?.consentId
                                                            }
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'This field is required.'
                                                                            : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                                                },
                                                            ]}
                                                        >
                                                            <Checkbox.Group size="large">
                                                                <CheckCustom>
                                                                    <Space direction="vertical">
                                                                        <Checkbox
                                                                            className={`bg-[#F4F6FC] rounded-lg px-4 py-2`}
                                                                            key={`${consent.sequence}_Accept`}
                                                                            style={{
                                                                                lineHeight:
                                                                                    '32px',
                                                                                '--checkbox-color':
                                                                                    '#1890FF',
                                                                            }}
                                                                            value={
                                                                                true
                                                                            }
                                                                        >
                                                                            {lang ===
                                                                            'en'
                                                                                ? 'Acknowledge'
                                                                                : 'รับทราบ'}
                                                                        </Checkbox>
                                                                    </Space>
                                                                </CheckCustom>
                                                            </Checkbox.Group>
                                                        </Form.Item>
                                                    ) : (
                                                        <Form.Item
                                                            className="initial"
                                                            name={
                                                                consent?.consentId
                                                            }
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'This field is required.'
                                                                            : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                                                },
                                                            ]}
                                                        >
                                                            <Radio.Group>
                                                                <Space>
                                                                    <RadioStyle>
                                                                        <Radio
                                                                            className={`bg-[#F4F6FC] rounded-lg px-4 py-2`}
                                                                            key={`${consent?.sequence}_Accept`}
                                                                            value={
                                                                                true
                                                                            }
                                                                            style={{
                                                                                lineHeight:
                                                                                    '32px',
                                                                            }}
                                                                        >
                                                                            {lang ===
                                                                            'en'
                                                                                ? 'I agree'
                                                                                : 'ยินยอม'}
                                                                        </Radio>
                                                                        <Radio
                                                                            className={`bg-[#F4F6FC] rounded-lg px-4 py-2`}
                                                                            key={`${consent?.sequence}_NotAccept`}
                                                                            value={
                                                                                false
                                                                            }
                                                                            style={{
                                                                                lineHeight:
                                                                                    '32px',
                                                                            }}
                                                                        >
                                                                            {lang ===
                                                                            'en'
                                                                                ? 'Decline'
                                                                                : 'ไม่ยินยอม'}
                                                                        </Radio>
                                                                    </RadioStyle>
                                                                </Space>
                                                            </Radio.Group>
                                                        </Form.Item>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    ))}
                                    <div className="text-sm font-base whitespace-pre-wrap indent-12 my-4">
                                        {lang === 'en'
                                            ? parse(
                                                  templateDetail?.certificationEn
                                              )
                                            : parse(
                                                  templateDetail?.certificationTh
                                              )}
                                    </div>
                                    {(templateDetail?.contactChannelTh ||
                                        templateDetail?.contactChannelEn) && (
                                        <div className="my-2">
                                            <div className="text-sm font-semibold my-2">
                                                {lang === 'en'
                                                    ? 'Contact channel'
                                                    : 'ช่องทางการติดต่อ'}
                                            </div>
                                            <div className="text-sm font-base whitespace-pre-wrap leading-6">
                                                {lang === 'en'
                                                    ? parse(
                                                          templateDetail?.contactChannelEn ||
                                                              '-'
                                                      )
                                                    : parse(
                                                          templateDetail?.contactChannelTh ||
                                                              '-'
                                                      )}
                                            </div>
                                        </div>
                                    )}

                                    <div className="text-sm font-base whitespace-pre-wrap my-4">
                                        {lang === 'en'
                                            ? 'This document was last updated on'
                                            : 'เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ'}{' '}
                                        {templateDetail?.effectiveDate
                                            ? getCurrentDate(
                                                  templateDetail?.effectiveDate?.split(
                                                      'T'
                                                  )[0] || '-'
                                              )
                                            : '-'}
                                    </div>
                                    <div
                                        className="my-2"
                                        style={{
                                            borderBottom: '1px solid #EDEEF9',
                                        }}
                                    ></div>
                                    <div className="text-sm font-semibold whitespace-pre-wrap">
                                        {lang === 'en'
                                            ? 'Provide consent information as of (date)'
                                            : 'ให้ข้อมูลความยินยอม ณ วันที่'}{' '}
                                        {getCurrentDate(new Date())}
                                    </div>
                                    {templateDetail?.isRequireOtp && (
                                        <div className="font-semibold space-y-4">
                                            <div>
                                                {lang === 'th'
                                                    ? 'กรุณาระบุอีเมลเพื่อยืนยันตัวตนด้วยรหัส OTP (One Time Password)'
                                                    : 'Please enter your email address to verify your identity with OTP (One Time Password)'}
                                            </div>
                                            <div>
                                                <Form.Item
                                                    label={
                                                        lang === 'th' ? (
                                                            <span>
                                                                อีเมล{' '}
                                                                {required_sign}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                Email{' '}
                                                                {required_sign}
                                                            </span>
                                                        )
                                                    }
                                                    extra={
                                                        isRequireOtp &&
                                                        parse(help)
                                                    }
                                                >
                                                    <div className="flex flex-col md:flex-row gap-2">
                                                        <Form.Item
                                                            name="email"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'This field is required.'
                                                                            : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                                                },
                                                                {
                                                                    type: 'email',
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'Please enter a valid email address.'
                                                                            : 'รูปแบบอีเมลไม่ถูกต้อง',
                                                                },
                                                            ]}
                                                            noStyle
                                                        >
                                                            <Input
                                                                disabled={
                                                                    isValidOtp
                                                                }
                                                                className="w-full md:w-72"
                                                                size="large"
                                                                placeholder={
                                                                    lang ===
                                                                    'th'
                                                                        ? 'ระบุอีเมลเพื่อรับ OTP'
                                                                        : 'Enter your email to receive OTP.'
                                                                }
                                                            />
                                                        </Form.Item>
                                                        <Button
                                                            disabled={
                                                                disabledEmail
                                                            }
                                                            type="primary"
                                                            size="large"
                                                            className="button-link"
                                                            onClick={getOtp}
                                                        >
                                                            {lang === 'th'
                                                                ? 'รับรหัส'
                                                                : 'Get OTP'}
                                                        </Button>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                            <div>
                                                <Form.Item
                                                    label={
                                                        lang === 'th' ? (
                                                            <span>
                                                                ป้อนรหัส OTP
                                                                ที่ส่งไปยังอีเมล{' '}
                                                                {required_sign}{' '}
                                                                {refCode &&
                                                                    `(รหัสอ้างอิง: ${refCode})`}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                Enter the OTP
                                                                sent to your
                                                                email{' '}
                                                                {required_sign}{' '}
                                                                {refCode &&
                                                                    `(Reference code: ${refCode})`}
                                                            </span>
                                                        )
                                                    }
                                                    extra={
                                                        isValidOtp && (
                                                            <span className="text-green-400 flex items-center gap-2">
                                                                <CheckCircleFilled />{' '}
                                                                {lang === 'th'
                                                                    ? 'ยืนยันรหัส OTP ถูกต้อง'
                                                                    : 'Confirm OTP is correct'}
                                                            </span>
                                                        )
                                                    }
                                                >
                                                    <div className="flex flex-col md:flex-row gap-2">
                                                        <Form.Item
                                                            name="otp"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'This field is required.'
                                                                            : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                                                },
                                                                {
                                                                    pattern:
                                                                        /^\d*$/,
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'Please enter only numbers.'
                                                                            : 'กรุณากรอกเฉพาะตัวเลขเท่านั้น',
                                                                },
                                                                {
                                                                    max: 6,
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'Please enter 6 digits.'
                                                                            : 'โปรดกรอกตัวเลขอย่างน้อย 6 หลัก',
                                                                },
                                                                {
                                                                    min: 6,
                                                                    message:
                                                                        lang ===
                                                                        'en'
                                                                            ? 'Please enter 6 digits.'
                                                                            : 'โปรดกรอกตัวเลขอย่างน้อย 6 หลัก',
                                                                },
                                                            ]}
                                                            noStyle
                                                        >
                                                            <Input
                                                                className="w-full md:w-72"
                                                                disabled={
                                                                    disableOtp ||
                                                                    isValidOtp
                                                                }
                                                                size="large"
                                                            />
                                                        </Form.Item>
                                                        <Button
                                                            disabled={
                                                                disableOtp ||
                                                                isValidOtp
                                                            }
                                                            type="primary"
                                                            size="large"
                                                            className="button-link"
                                                            onClick={verifyOtp}
                                                        >
                                                            {lang === 'th'
                                                                ? 'ยืนยัน OTP'
                                                                : 'Confirm OTP'}
                                                        </Button>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    )}
                                    <div className="flex text-center justify-center items-center mt-2">
                                        <Form.Item>
                                            <Button
                                                size="large"
                                                type="primary"
                                                htmlType="submit"
                                                className="px-9 button-link"
                                            >
                                                {lang === 'en'
                                                    ? 'Submit'
                                                    : 'ยืนยัน'}
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </div>
                            </Form>
                        ) : (
                            <div className="whitespace-pre-line p-6 mt-2 leading-7 overflow-auto max-h-[700px]">
                                <div className="text-center text-sm space-y-2 my-56">
                                    <IconNoData />
                                    <p className="text-[#65707A] text-[14px]">
                                        {lang === 'en'
                                            ? 'No Data'
                                            : 'ไม่พบข้อมูล'}
                                    </p>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <Complete />
                )}
            </TemplateDetail>

            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#1890ff',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const CheckCustom = styled.div`
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #1890ff;
        border: 1px solid #1890ff;
    }
    .ant-checkbox-checked:hover .ant-checkbox-inner:hover {
        border-color: #1890ff;
        border: 1px solid #1890ff;
    }
    .ant-checkbox-input:focus + .ant-checkbox-inner,
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner {
        border-color: #1890ff;
    }
    .ant-checkbox-checked:hover {
        border-color: #1890ff !important;
    }
`;

const TemplateDetail = styled.div`
    a {
        color: #1890ff !important;
    }
`;

const RadioStyle = styled.div`
    .ant-radio-inner:after {
        background-color: #1890ff !important;
        border: 1px solid #1890ff !important;
    }
    .ant-radio-inner:hover {
        border: 1px solid #1890ff !important;
    }
    .ant-radio-checked:after {
        background-color: #1890ff !important;
        box-shadow: 0 0 0 2px #0974d745;
        border: 1px solid #1890ff !important;
    }
    .ant-radio-checked .ant-radio-inner {
        border-color: #1890ff !important;
        box-shadow: 0 0 0 2px #0974d745;
    }
    .ant-radio-checked:hover,
    .ant-radio-inner:hover {
        border-color: #1890ff !important;
    }
    .ant-radio-inner:focus {
        border-color: #1890ff !important;
    }
    .ant-radio-input:focus + .ant-radio-inner,
    .ant-radio-wrapper:hover .ant-radio,
    .ant-radio:hover .ant-radio-inner {
        border-color: #1890ff;
    }
    .ant-radio-input:focus + .ant-radio-inner:focus,
    .ant-radio:focus,
    .ant-radio-inner:focus {
        box-shadow: 0 0 0 2px #0974d745;
    }
`;
